import { useMutation, useQuery, useQueryClient } from "react-query";
import Http from "../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../core/HttpRequest";
import { IExpenseCategory } from "../ExpenseCategory.type";
import {
  addCategoryExpense,
  deleteDetailCategoryExpense,
  getDetailCategoryExpense,
  getListCategoryExpense,
  updateCategoryExpense,
} from "./service";
import { useToast } from "../../../context/toast/ToastContext";

export const useGetListCategoryExpense = ({
  page,
  perPage,
  keyword,
}: HttpBaseRequest) => {
  return useQuery({
    queryKey: ["list-category-expense", page, perPage, keyword],
    queryFn: () => getListCategoryExpense({ page, perPage, keyword }),
  });
};

export const useGetDetailCategoryExpense = ({
  expense_category_id,
}: HttpBaseRequest<{ expense_category_id: string }>) => {
  return useQuery({
    queryKey: ["detail-expense-category", expense_category_id],
    queryFn: () => getDetailCategoryExpense({ expense_category_id }),
  });
};

export const useAddCategoryExpense = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ name }: { name: string }) => addCategoryExpense({ name }),
    onSuccess: (e) => {
      if (e.data.statusCode === 200) {
        toast.show("Berhasil menambahkan Kategori Expense baru");
        queryClient.invalidateQueries();
      } else if (e.data.statusCode === 400) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      } else if (e.data.statusCode === 101) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      }
    },
  });
};

export const useUpdateCategoryExpense = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      name,
      expense_category_id,
    }: {
      name: string;
      expense_category_id: string;
    }) => updateCategoryExpense({ name, expense_category_id }),
    onSuccess: (e) => {
      if (e.data.statusCode === 200) {
        toast.show("Berhasil update Kategori Expense");
        queryClient.invalidateQueries();
      } else if (e.data.statusCode === 400) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      } else if (e.data.statusCode === 101) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      }
    },
  });
};

export const useDeleteCategoryExpense = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      expense_category_id,
    }: HttpBaseRequest<{ expense_category_id: string }>) => {
      return deleteDetailCategoryExpense({
        expense_category_id: expense_category_id,
      });
    },
    onSuccess: (e) => {
      if (e.data.statusCode === 200) {
        toast.show("Berhasil delete Kategori Expense");
        queryClient.invalidateQueries();
      } else if (e.data.statusCode === 400) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      } else if (e.data.statusCode === 101) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      }
    },
  });
};
